export default __webpack_public_path__ + "static/media/aboutMe.9ff95d97.png";